import { ServerValueEnum } from '../../utils/enum'

const ConversationAnchorPoints = new ServerValueEnum({
  CONTINUATION: { serverValue: 'continuation' },
  CONVERSATION_END: { serverValue: 'conversation_end' },
  FIRST_UNREAD_ITEM: { serverValue: 'first_unread_item' },
})

export default ConversationAnchorPoints
